import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, of } from 'rxjs';
import { UserService } from '../auth/user.service';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../environments/environment';

@Injectable({
providedIn: 'root'
})
export class TrackService {

showNewMapWizard = new BehaviorSubject<boolean>(false);
constructor(
    private readonly httpClient: HttpClient,
    private readonly userService: UserService,
) {
}

createOrUpdateVisit(): Promise<any> {
    try {
        if (this.userService.user) {
            return firstValueFrom(of({}));
        }
        const track = JSON.parse(localStorage.getItem('ref'));
        return firstValueFrom(this.httpClient.put(`${environment.api_server_url}/api/visit-tracking`, { track }, { }));
    } catch (err) {
        console.log(err);
    }
    return firstValueFrom(of({}));
}

trackVisit(params: any): void {
    try {
        const jsonParams = {
            ref: params.ref,
            utm_source: params.utm_source,
            utm_medium: params.utm_medium,
            utm_term: params.utm_term,
            utm_campaign: params.utm_campaign,
        }
        jsonParams['referer'] = document.referrer;
        if (!params.ref) {
            jsonParams.ref = 'no_source';
        }
            if (localStorage.getItem('ref')) {
                const cookieParams = JSON.parse(localStorage.getItem('ref'));
                if (cookieParams.uuid) {
                    jsonParams['uuid'] = cookieParams.uuid;
                }
                localStorage.setItem('ref', JSON.stringify(jsonParams));
            } else {
                const uuid = uuidv4();
                jsonParams['uuid'] = uuid;
                localStorage.setItem('ref', JSON.stringify(jsonParams));
            }
            this.createOrUpdateVisit().then(() => {});
        } catch (err) {
            console.log(err);
        }
    }

}
